// extracted by mini-css-extract-plugin
export default {"btn1":"error_btn1__g5v-Z","status":"error_status__IdRMw","errorMessage":"error_errorMessage__QiO11","pageContainer":"error_pageContainer__1s5sE","pageRow":"error_pageRow__NuZPB"};